import { BaseService } from "src/services/baseService";
import { UserEmailAPIService } from "./userEmailAPIService";
import { EmailVerificationStatus } from "src/types";

class UserEmailService extends BaseService<UserEmailAPIService> {
  async checkUserEmailVerificationStatus(): Promise<EmailVerificationStatus> {
    return await this.apiService.patchUserEmailVerification();
  }

  async sendUserVerificationEmail(): Promise<EmailVerificationStatus> {
    return await this.apiService.postUserEmailVerificationEmail();
  }
}

export { UserEmailService };
